import { StyleSheet } from 'react-native';
import { Colors, SharedUnvalidatedStyles } from '@shared/styles';

export const Styles = StyleSheet.create({
  mentionRowImage: {
    width: 28,
    height: 28,
    borderRadius: 54,
    overflow: 'hidden',
  },
  mentionRowHover: {
    backgroundColor: Colors.v2.gray05,
  },
  mentionList: {
    backgroundColor: 'white',
    borderRadius: 10,
    overflow: 'hidden',
    maxHeight: 48 * 3.5, // 48px is the empirically tested height of a mention row
    // hack to get border radius to hide overflow (eg on item hover => changes bg color)
    // https://stackoverflow.com/a/25206004/9117995
    zIndex: 1,
    // On web, the shadow only works inside the MBAnimation the mention list is wrapped in
    ...SharedUnvalidatedStyles.shadow,
  },
});
